import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { getCharacterList } from '~/api';
import { GetAllCharacterListData, GetAllCharacterListRequest } from '~/types';
import { MINUTE } from '~/constants';
import characterKey from './characterKey';

export const CHARACTER_FETCH_SIZE = 10;

const useGetSearchCharacterListQuery = (
  request: GetAllCharacterListRequest,
  staleTime = 5 * MINUTE,
) => {
  return useSuspenseInfiniteQuery({
    queryKey: characterKey.getSearchCharacterList(request),
    queryFn: ({ pageParam }) =>
      getCharacterList({
        search: request.query,
        page: pageParam,
        page_size: CHARACTER_FETCH_SIZE,
      }),
    initialPageParam: 1,
    getNextPageParam: (response, _, lastPageParam) => {
      if (response.status !== 200) return undefined;
      if (response.data.length < CHARACTER_FETCH_SIZE) return undefined;

      const nextPage = lastPageParam + 1;
      return response.status === 200 && response.data.length === 0
        ? undefined
        : nextPage;
    },
    select: (response) => ({
      pages: response.pages.flatMap((page) => {
        if (page.data) return page.data as GetAllCharacterListData[];
        return [];
      }),
      pageParams: response.pageParams,
      total: response.pages[0].data_additional?.total,
    }),

    staleTime,
  });
};

export default useGetSearchCharacterListQuery;
